module.exports = __webpack_public_path__ + "img/short04.9e87c304.jpg";